import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { biometrics } from '../../platform/biometrics';
import { runtime } from '../../platform/runtime';
import Profile from './Profile';

export default function ProfileRoute() {
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (!runtime.isNative()) return;
        let active = true;
        setError(false);
        biometrics.status().then(value => {
            if (active) setStatus(value);
        }).catch(() => { if (active) setError(true); });
        return () => { active = false; };
    }, [attempt]);

    // Resolve native state before mounting any profile content. Never briefly
    // display an unchecked switch while the saved setting is still unknown.
    if (runtime.isNative() && !status) return (
        <Box sx={{ minHeight: '50vh', display: 'grid', placeItems: 'center', p: 2 }}>
            {error ? <Alert severity="error" action={<Button onClick={() => setAttempt(value => value + 1)}>Retry</Button>}>
                Unable to load biometric settings.
            </Alert> : <CircularProgress aria-label="Loading profile" />}
        </Box>
    );
    return <Profile biometricStatus={status} onBiometricStatusChange={setStatus} />;
}
